import {
  IMAGE_ACTION,
  IMAGE_ASPECT_RATIOS,
  IMAGE_MODE,
  IMAGE_MODEL_ID,
  INPUT_IMAGE_ROLE,
  MAX_IMAGE_STYLES,
  OUTPUT_PURPOSES,
  PROVIDER,
} from 'Pods/ThreeDStudio/Store/constants'

export default {
  "model_id": IMAGE_MODEL_ID.FLUX_SIMILAR_TO_FLUX2_PRO,
  "provider": PROVIDER.FLUX,
  "action": IMAGE_ACTION.SIMILAR_TO,
  "mode": IMAGE_MODE.FLUX2_PRO,
  "input_schema": {
    "type": "object",
    "properties": {
      // Optional for the backend, whose prompt template carries the "similar object"
      // instruction; the composer always sends the user's text alongside it.
      "prompt": {
        "type": "string",
      },
      // The object image first, then up to MAX_IMAGE_STYLES style references; exactly one
      // object is enforced server-side.
      "input_image": {
        "type": "array",
        "minItems": 1,
        "maxItems": 1 + MAX_IMAGE_STYLES,
        "items": {
          "type": "object",
          "properties": {
            "asset_id": { "type": "integer" },
            "role": { "type": "string", "enum": [INPUT_IMAGE_ROLE.OBJECT, INPUT_IMAGE_ROLE.STYLE] },
          },
          "required": ["asset_id", "role"],
        },
      },
      "output_purpose": {
        "type": "string",
        "enum": OUTPUT_PURPOSES,
      },
      "aspect_ratio": {
        "type": "string",
        "enum": IMAGE_ASPECT_RATIOS,
      },
      "num_images": {
        "type": "integer",
        "minimum": 1,
        "maximum": 4,
      },
    },
    "required": ["input_image"],
  },
  "ui_schema": {},
}
